import { Application } from '@hotwired/stimulus'

const stimulusApp = Application.start()
stimulusApp.debug = false

// Secondary bundles and legacy scripts register controllers through the
// global (pre-bundler behavior).
window.stimulusApp = stimulusApp

export { stimulusApp }
